import React from "react";

export const BrandStatement = () => {
  return (
    <section
      data-testid="brand-statement-section"
      className="relative bg-stone-950 py-24 sm:py-32 lg:py-40 border-t border-stone-900"
    >
      <div className="max-w-6xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <div className="lg:col-span-5">
            <p className="text-orange-500 font-sans-display text-xs uppercase tracking-[0.32em] mb-6">
              The Brand
            </p>
            <h2
              className="font-serif-display text-stone-50 text-4xl sm:text-5xl lg:text-6xl leading-[0.95] tracking-tight"
              data-testid="brand-statement-headline"
            >
              Authentic Flavours.
              <br />
              <span className="text-stone-400">Cultural Roots.</span>
              <br />
              <em className="not-italic text-orange-500">Elevated Experiences.</em>
            </h2>
          </div>

          <div className="lg:col-span-6 lg:col-start-7 self-end">
            <p className="font-sans-display text-stone-300 text-base sm:text-lg leading-relaxed">
              From bold bar bites to nourishing healthy snacks and satisfying
              main courses, Authentic Kitchen brings global flavours to your
              table — crafted with purpose, culture, and quality.
            </p>

            <div className="mt-10 pt-10 border-t border-stone-800">
              <p className="font-serif-display italic text-stone-100 text-2xl sm:text-3xl leading-snug">
                Food that connects.
                <br />
                Flavours that represent.
                <br />
                <span className="text-orange-500">Experiences that last.</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandStatement;
